<script setup>
import Login from './pages/Login.vue';
import Reset from './pages/ResetPassword.vue';
import Sidebar from './components/Sidebar.vue';
import Consumer from './pages/Consumer.vue';
import Home from './pages/Home.vue';
import Military from "./pages/Military.vue"
import NotFound from "./pages/404.vue";
import Containers from './pages/Containers.vue';
import Service from './pages/Service.vue';
import Ports from './pages/PortAgents.vue';
import Users from './pages/Users.vue';
import Partners from './pages/Partners.vue';
import ProNumber from './pages/ProNumber.vue';
import Contact from "./pages/ContactUs.vue";
</script>

<script>
export default {
    computed: {
        isHome() {
            return this.$route.fullPath === "/";
        },
		isMeContact() {
			return this.$route.fullPath === "/me/contact-us"
		},
		isContact() {
			return this.$route.fullPath === "/contact-us"
		},
        isLogin() {
            return this.$route.fullPath === "/login";
        },
		isReset() {
            return this.$route.fullPath.indexOf("/reset-password") !== -1;
        },
        isMilitary() {
            return this.$route.fullPath.indexOf("/military-shipment") !== -1;
        },
        isConsumer() {
            return this.$route.fullPath.indexOf("/consumer-shipment") !== -1;
        },
        isContainer() {
            return this.$route.fullPath.indexOf("/admin/container-types") !== -1;
        },
        isService() {
            return this.$route.fullPath.indexOf("/admin/service-types") !== -1;
        },
        isPort() {
            return this.$route.fullPath.indexOf("/admin/ports-agents") !== -1;
        },
        isUser() {
            return this.$route.fullPath.indexOf("/admin/users") !== -1;
        },
		isPartner() {
			return this.$route.fullPath.indexOf('/partners/users') !== -1;
		},
		isProNumber() {
			return this.$route.fullPath.indexOf("/admin/config") !== -1;
		}
    },
    methods: {
        // Add this method to handle login response
        storeAuthData(loginResponse) {
            // Store auth token
            localStorage.setItem('auth_token', loginResponse.token.token);
            localStorage.setItem('refresh_token', loginResponse.token.refresh_token);
            
            // Store user info
            localStorage.setItem('user', JSON.stringify(loginResponse.user));
            
            // Store tenant info
            localStorage.setItem('tenant', JSON.stringify(loginResponse.tenant));
            
            // Store tenant_id specifically as requested
            localStorage.setItem('tenant_id', loginResponse.tenant.id);
            
            // Store token expiry
            localStorage.setItem('token_expires_at', loginResponse.token.expires_at);
        }
    }
}
</script>

<template>
    <Login v-if="isLogin" />
    <Reset v-else-if="isReset" />
	<Contact v-else-if="isContact" />
    <div v-else-if="!isLogin" class="max-w-full overflow-x-hidden h-[100vh] bg-page flex flex-row gap-x-6 p-4">
        <Sidebar class="!z-[20]" />
        <Home v-if="isHome" />
        <Military v-else-if="isMilitary" />
        <Consumer v-else-if="isConsumer" />
        <Containers v-else-if="isContainer" />
        <Service v-else-if="isService" />
        <Ports v-else-if="isPort" />
        <Users v-else-if="isUser" />
		<Partners v-else-if="isPartner" />
		<ProNumber v-else-if="isProNumber" />
		<Contact v-else-if="isMeContact" />
    </div>
    <!-- Has to be the last thinggy. -->
    <NotFound v-else />
</template>
